/* eslint-disable import/no-duplicates */
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { Popover, Avatar } from '@jjj/components';
import authAction from '../../../redux/auth/actions';
import appAction from '../../../redux/app/actions';
import TopbarDropdownWrapper from '../topbarDropdown.style';
import { isProduction } from '../../../settings';
import { UserTitle, IconWrapper, UserAvatarWrapper, LogoutButton } from './topbarUser.style';
import { t } from '../../../i18n';

const { logout } = authAction;
const { closeAll } = appAction;

class TopbarUser extends Component {
  state = { visible: false };

  handleVisibleChange = () => {
    const { visible } = this.state;
    this.setState({ visible: !visible });
  };

  onLogout = () => {
    this.props.logout();
    this.props.closeAll();
  };

  getProfileInitials = ({ name, lastName }) => {
    if (name && lastName) {
      const [nameInitial] = name;
      const [lastNameInitial] = lastName;

      return `${nameInitial}${lastNameInitial}`;
    }

    return '';
  };

  render() {
    const { profile = {} } = this.props;

    const content = (
      <TopbarDropdownWrapper className="isoUserDropdown" onClick={this.handleVisibleChange}>
        {!isProduction && (
          <Link className="isoDropdownLink" to="/settings" data-cy="topbar-settings-link">
            {t('dash.topbar.settings_label')}
          </Link>
        )}
        <Link className="isoDropdownLink" to="/profile" data-cy="topbar-profile-link">
          {t('dash.topbar.edit_profile_label')}
        </Link>
        <LogoutButton
          type="button"
          className="isoDropdownLink logout"
          onClick={this.onLogout}
          data-cy="topbar-logout-link"
        >
          {t('dash.topbar.logout_label')}
        </LogoutButton>
      </TopbarDropdownWrapper>
    );

    return (
      <div>
        <Popover
          content={content}
          trigger="click"
          open={this.state.visible}
          onOpenChange={this.handleVisibleChange}
          placement="bottomRight"
          popupAlign={{ offset: [-16, 0] }}
        >
          {profile && profile.name && (
            <UserTitle>
              <span className="user">{profile.name}</span>
              <IconWrapper>
                <i className="fas fa-chevron-down" />
              </IconWrapper>
            </UserTitle>
          )}
          <div className="isoImgWrapper">
            {profile && profile.avatar_url && profile.avatar_url !== 'nophoto' ? (
              <UserAvatarWrapper avatar={profile.avatar_url} />
            ) : (
              <Avatar>{this.getProfileInitials(profile)}</Avatar>
            )}
          </div>
        </Popover>
      </div>
    );
  }
}

export default connect(
  state => ({
    profile: state.Auth.profile,
  }),
  dispatch => ({
    logout: /* istanbul ignore next */ () => dispatch(logout()),
    closeAll: /* istanbul ignore next */ () => dispatch(closeAll()),
  }),
)(TopbarUser);
